import React from 'react'
import { Link } from 'react-router-dom'
import { Icon } from 'loyal-react'

const GuestUserProfile = () => (
  <Link
    title='Olá, faça o seu login ou cadastre-se'
    to='/auth/login'
    className='profile-menu profile zindex-high col d-none d-md-block order-md-3 px-2'
    role='button'
  >
    <div className='row justify-content-between align-items-center h-100 px-0'>
      <div className='col-auto'>
        <Icon iconName='icon_profile' className='color-brand-5' />
      </div>
      <div className='col-8 px-0 color-brand-5 profile-infos'>
        <p className='nowrap txt-body-sm'>Olá, faça o seu login</p>
        <p className='nowrap txt-body-sm'>ou cadastre-se</p>
      </div>
      <div className='col-1 d-none d-lg-block'>
        <Icon iconName='icon_right' className='icon-ssm color-brand-5' />
      </div>
    </div>
  </Link>
)

export default GuestUserProfile



// WEBPACK FOOTER //
// ./src/App/Header/GuestHeader/GuestUserProfile.js